import React, { Component } from 'react'
import { InputNumber } from 'antd'
import { getAttribute } from '../utils/models'
import FormItem from './FormItem'
import _ from 'lodash'

class Numeric extends Component {

    render() {
        const { getFieldDecorator } = this.props.form
        const attribute = getAttribute(this.props.model, this.props.attribute)

        let inputProps = {}
        let { fieldSettings } = this.props

        if (attribute && attribute.currency) {
            _.first(this.props.fieldSettings.rules).validator = (rule, value, callback) => {
                if (value > 0) {
                    callback()
                } else {
                    callback('Error')
                }
            }
            fieldSettings.initialValue = this.props.value || null

            inputProps = {
                formatter: value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                parser: value => value.replace(/\$\s?|(,*)/g, '')
            }
        }

        return (
            <FormItem {...this.props}>
                {getFieldDecorator(this.props.attribute, fieldSettings)(
                    <InputNumber size='large' disabled={this.props.disabled} style={{ width: '100%' }} onChange={this.props.handleChange} {...inputProps} />
                )}
            </FormItem >
        )
    }

}

export default Numeric


// WEBPACK FOOTER //
// ./src/inputs/Numeric.js